import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: '16px',
    cursor: 'pointer',
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  }
}))

export default useStyles
